import { render } from "./DarkThemeAlert.vue?vue&type=template&id=0ccad48b&scoped=true"
import script from "./DarkThemeAlert.vue?vue&type=script&lang=js"
export * from "./DarkThemeAlert.vue?vue&type=script&lang=js"

import "./DarkThemeAlert.vue?vue&type=style&index=0&id=0ccad48b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ccad48b"]])

export default __exports__